module.exports = __webpack_public_path__ + "static/media/beach_marker_light_blue.c838ab92.svg";